import ENV from '../../config/env';
import { getCookie } from '../utils/cookieStorage';

class ApiClient {
  constructor(baseUrl) {
    this.baseUrl = baseUrl;
  }

  // Helper to retrieve auth token from cookies
  getToken() {
    return getCookie('student_auth_token');
  }

  // Main request wrapper
  async request(endpoint, options = {}) {
    const url = `${this.baseUrl}${endpoint}`;

    const isFormData = options.body instanceof FormData;

    // Setup headers
    const headers = {
      ...options.headers,
    };

    if (!isFormData) {
      headers['Content-Type'] = 'application/json';
    }

    // Inject Auth token if available
    const token = this.getToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const config = {
      ...options,
      headers,
    };

    if (config.body && typeof config.body === 'object' && !isFormData) {
      config.body = JSON.stringify(config.body);
    }

    try {
      const response = await fetch(url, config);

      if (!response.ok) {
        let errorData = null;
        try {
          const contentType = response.headers.get('content-type');
          if (contentType && contentType.includes('application/json')) {
            errorData = await response.json();
          } else {
            errorData = await response.text();
          }
        } catch (_) {}
        const error = new Error(errorData?.message || `HTTP error! status: ${response.status}`);
        error.status = response.status;
        error.data = errorData;
        throw error;
      }

      if (options.responseType === 'blob') {
        return await response.blob();
      }

      const contentType = response.headers.get('content-type');
      if (contentType && contentType.includes('application/json')) {
        return await response.json();
      } else {
        return await response.text();
      }
    } catch (err) {
      console.error(`API Request Failure: [${config.method || 'GET'}] ${endpoint}`, err);
      throw err;
    }
  }

  get(endpoint, options = {}) {
    return this.request(endpoint, { ...options, method: 'GET' });
  }

  post(endpoint, body, options = {}) {
    return this.request(endpoint, { ...options, method: 'POST', body });
  }

  put(endpoint, body, options = {}) {
    return this.request(endpoint, { ...options, method: 'PUT', body });
  }

  delete(endpoint, options = {}) {
    const { data, ...rest } = options;
    return this.request(endpoint, { ...rest, method: 'DELETE', body: data });
  }
}

export const apiClient = new ApiClient(ENV.API_URL);
export const v2ApiClient = new ApiClient(ENV.API_URL.replace('/api/v1/web', '/api/v2/web'));
export const ssoApiClient = new ApiClient(ENV.API_SSO_URL);
export default apiClient;

